export default [
  {
    title: 'Analytics',
    route: 'DashboardChat',
    icon: 'GridIcon',
    resource: 'CHATBOOSTER',
    action: 'chatbooster',
  },
  {
    title: 'Meus Videos',
    route: 'Meus-Videos',
    icon: 'VideoIcon',
    // acl: {
    resource: 'VSLBOOSTER',
    action: 'vslbooster',
    // },
  },
  {
    title: 'Chat',
    icon: 'MessageSquareIcon',
    route: 'chats',
    resource: 'CHATBOOSTER',
    action: 'chatbooster',
  },
  {
    title: 'Leads',
    icon: 'UsersIcon',
    route: 'leads',
    resource: 'CHATBOOSTER',
    action: 'chatbooster',
  },
  {
    title: 'Integrações',
    icon: 'Share2Icon',
    route: 'integracoes',
    resource: 'CHATBOOSTER',
    action: 'chatbooster',
  },

  // {
  //   title: 'Testes A/B ',
  //   route: 'teste-ab',
  //   icon: 'ThermometerIcon',
  // },

  // {
  //   title: 'Segurança',
  //   route: 'Seguranca',
  //   icon: 'ShieldIcon',
  // },
  {
    title: 'Webinário',
    route: 'webinar-simulator',
    icon: 'VideoIcon',
    resource: 'VSLBOOSTER',
    action: 'vslbooster',
  },
  {
    title: 'Mapa de Calor',
    route: 'heatmap',
    icon: 'ActivityIcon',
    resource: 'VSLBOOSTER',
    action: 'read',
  },
  {
    title: 'Fale Conosco',
    route: 'fale-conosco',
    icon: 'MessageCircleIcon',
    resource: 'all',
    action: 'read',
  },
  {
    title: 'Documentação',
    route: 'documentacao',
    icon: 'BookIcon',
    resource: 'all',
    action: 'read',
  },
  {
    title: 'Administração',
    icon: 'SettingsIcon',
    resource: 'all',
    action: 'manage',
    children: [
      {
        title: 'Dashboard',
        route: 'admin-overview',
        icon: 'BarChart2Icon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Observabilidade',
        route: 'admin-observabilidade',
        icon: 'ActivityIcon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Usuários & Clientes',
        route: 'admin-usuarios',
        icon: 'UsersIcon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Blog',
        route: 'admin-blog',
        icon: 'BookOpenIcon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Afiliados',
        route: 'admin-afiliados',
        icon: 'UsersIcon',
        resource: 'all',
        action: 'manage',
      },
      {
        title: 'Configurações',
        route: 'admin-configuracoes',
        icon: 'SlidersIcon',
        resource: 'all',
        action: 'manage',
      },
    ],
  },
]
